import { FunctionComponent, useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ChannelContext, ConfigContext } from '../../context';
import {
  ConfigurationLink,
  FooterCopy,
  getOrganisationDomain,
  IconLabelSizes,
  isAdminLayout,
  LayoutSwitcher,
} from '../../shared';

import classNames from 'classnames';
import classes from './Footer.module.scss';

export const Footer: FunctionComponent = () => {
  const { t } = useTranslation();

  const { dashboardUrl } = { ...useContext(ChannelContext).channel };

  const { links } = useContext(ConfigContext).config.elements.footer;

  const renderPrivacySettingsLink = useMemo(
    () =>
      Boolean(
        !isAdminLayout() &&
          ['ruhrnachrichten1', 'ruhr_nachrichten', 'buzz04ruhr_nachrichten'].includes(
            getOrganisationDomain()
          )
      ),
    []
  );

  const renderFooterLinks = useMemo(
    () =>
      links.map((link) => (
        <ConfigurationLink
          key={link.title}
          link={link}
          labelSize={IconLabelSizes.small}
          labelClassName={classes['footer__links-item-label']}
        />
      )),
    [links]
  );

  return (
    <div className={classes['footer']}>
      {dashboardUrl && <LayoutSwitcher />}

      {Boolean(renderFooterLinks.length || renderPrivacySettingsLink) && (
        <div className={classes['footer__links']}>
          {renderFooterLinks}
          {renderPrivacySettingsLink && (
            <a
              href={'?cmpscreen'}
              className={classNames(
                'cmpfooterlink cmpfooterlinkcmp',
                classes['footer__links-privacy-settings']
              )}
            >
              {t('footer.privacy-settings')}
            </a>
          )}
        </div>
      )}

      <FooterCopy />
    </div>
  );
};
